<template>
  <div v-loading="loading">
    <div class="capacity-module-container">
      <div class="capacity-module-top">
        <div style="display: flex">
          <strong>数据存储明细</strong>
        </div>
      </div>
      <div class="capacity-module-middle">
        <div class="capacity-module-select">
          <el-select
            v-model="type"
            placeholder="请选择"
            size="small"
            style="width: 120px"
            popper-class="iottableselectoption"
            @change="setDatas"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="capacity-module-filter">
          <div class="date-picker">
            <el-date-picker
              v-model="daterange"
              :clearable="false"
              style="width: 230px"
              size="small"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              :value-format="'yyyy/MM/dd'"
              @change="dateChange"
            >
            </el-date-picker>
          </div>
          <div class="timecategory-group" style="margin: 0 15px">
            <el-radio-group v-model="timecategory" @change="setDateRange">
              <el-radio-button label="7">
                <span>周</span>
              </el-radio-button>
              <el-radio-button label="30">
                <span>月</span>
              </el-radio-button>
              <el-radio-button label="365">
                <span>年</span>
              </el-radio-button>
            </el-radio-group>
          </div>
          <button
            type="button"
            class="refresh-btn"
            title="刷新"
            @click="getData"
          >
            <i class="el-icon-refresh"></i>
          </button>
        </div>
        <div class="capacity-module-content">
          <div class="capacity-module-charts">
            <div
              class="capacity-module-chart"
              ref="lineChart"
              style="width: 100%;margin-top:40px"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="capacity-module-container">
      <div class="capacity-module-top">
        <div></div>
        <el-button
          class="capacity-module-btn"
          title="导出"
          :loading="exloading"
          size="mini"
          @click="exportExcel"
        >
          <i class="el-icon-download"></i>
          <span style="margin-left: 0">导出</span>
        </el-button>
      </div>
      <div class="capacity-module-middle">
        <div class="capacity-module-content">
          <div class="capacity-module-table">
            <el-table
              class="aeroiot-table"
              :data="tableData"
              border
              style="width: 100%"
              size="small"
            >
              <el-table-column
                label="序号"
                width="60"
                align="center"
                type="index"
                class-name="tableindex"
                fixed
              >
              </el-table-column>
              <el-table-column
                fixed
                prop="typename"
                align="center"
                label="数据类型"
                width="180"
              >
              </el-table-column>
              <el-table-column
                v-for="(item, i) in titleDatas"
                :key="'index' + i"
                align="center"
                sortable
                :prop="item.dayTime"
                :label="item.dayTime"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row[item.dayTime] }}GB</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import c from "@/utils/common";
export default {
  data() {
    return {
      daterange: "",
      timecategory: 7,
      loading: false,
      exloading: false,
      options: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "传感器采集数据",
        },
        {
          value: 2,
          label: "人工上传数据",
        },
      ],
      type: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > new Date().getTime()-1000 * 60 * 60 * 24;
        },
      },
      tableData: [],
      titleDatas: [],
      total: 100,
      pagesize: 10,
      pagesizes: [10, 50, 100],
      pageIndex: 1,
    };
  },
  mounted() {
    this.lineChart = echarts.init(this.$refs.lineChart);
    this.setDateRange();
  },
  methods: {
    setDateRange() {
      const endTime = new Date().getTime() - 1000 * 60 * 60 * 24;
      const startTime = endTime - this.timecategory * 1000 * 60 * 60 * 24;
      this.daterange = [
        c.formatTime(startTime, "Y/M/D"),
        c.formatTime(endTime, "Y/M/D"),
      ];
      this.getData();
    },
    dateChange(){
      this.timecategory = 0;
      this.getData();
    },
    setDatas() {
      const data = this.allData;
      if (this.type == 0) {
        const serieData = [
          {
            datas: data.totalSensorDatas,
            pointTypeName: "传感器采集数据",
          },
          {
            datas: data.totalMeasureDatas,
            pointTypeName: "人工上传数据",
          },
        ];
        this.initLineChart(serieData);
        serieData.push({
          datas: data.totalDatas,
          pointTypeName: "全部",
        });
        this.buildTableData(serieData);
      } else if (this.type == 1) {
        this.initLineChart(data.sensorStatDatas);
        this.buildTableData( data.sensorStatDatas);
      } else if (this.type == 2) {
        this.initLineChart(data.measureStatDatas);
        this.buildTableData( data.measureStatDatas);
      }
    },
    buildTableData(list) {
      if(list.length>0)this.titleDatas = list[0].datas;
      else this.$message.info("暂无数据");
      const tableData = [];
      list.map((item) => {
        const tableItem = {
          typename: item.pointTypeName,
        };
        item.datas.map((ditem=>{
          tableItem[ditem.dayTime] = ditem.allSize
        }))
        tableData.push(tableItem);
      });
      this.tableData =  tableData;
    },
    getData() {
      this.loading = true;
      var statApi = this.$apis.storagedetails;
      this.$axios
        .get(statApi, {
          params: {
            startTime: this.daterange[0],
            endTime: this.daterange[1],
            type: this.type,
          },
        })
        .then(
          (response) => {
            if (response.status === 200 && response.data) {
              var result = response.data;
              if (result.code === 200) {
                if (result.data) {
                  this.allData = result.data;
                  this.setDatas();
                }
              } else {
                console.log("物联网设备统计数据查询失败:" + result.message);
              }
            } else {
              console.log("物联网设备统计数据查询失败:" + response.message);
            }
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            this.$message.error("加载数据失败！");
          }
        );
    },
    initLineChart(datas) {
      const legenddata = [];
      const serie = [];
      const colors = ["#6C85FF", "#FEBE32"];
      datas.map((item, i) => {
        legenddata.push(item.pointTypeName);
        const serieitem = {
          name: item.pointTypeName,
          type: "line",
          showSymbol: false,
          itemStyle: {
            color: colors[i] ? colors[i] : null,
          },
          lineStyle: {
            color: colors[i] ? colors[i] : null,
            shadowColor: "rgba(0,0,0,0.07)",
            shadowBlur: 8,
            shadowOffsetY: 4,
          },
          data: [],
        };
        item.datas.map((ditem) => {
          serieitem.data.push([ditem.dayTime, ditem.allSize]);
        });
        serie.push(serieitem);
      });
      const chartoption = {
        legend: {
          top: 15,
          left: "center",
          itemGap: 30,
          data: legenddata,
          type: "scroll",
        },
        tooltip: {
          trigger: "axis",
          confine: true,
          formatter: (param) => {
            console.log(param)
            var html ="<strong>" + param[0].axisValue +"<strong>";
            param.map((item,i)=>{
              if(i%3==0)html=html+"<br>";
              html=html+item.marker+item.seriesName +"："+item.value[1] +'<span style="display:inline-block;width:20px"></span>'
            })
            return html;
          },
        },
        grid: {
          top: "60",
          left: "20",
          right: "20",
          bottom: "8",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          axisTick: {
            lineStyle: {
              color: "#E2E4E7",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#E2E4E7",
            },
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#6E7079",
              fontSize: 13,
            },
          },
          z: 1,
        },
        yAxis: {
          type: "value",
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            formatter: "{value} GB",
            textStyle: {
              color: "#3C414F",
              fontSize: 12,
            },
          },
          splitLine: {
            lineStyle: {
              color: ["#E2E4E7"],
              type: "dashed",
            },
          },
        },
        series: serie,
      };
      this.lineChart.setOption(chartoption, true, true);
    },
    exportExcel() {
      this.exloading = true;
      let statApi = this.$apis.detailexport;
      this.$axios
        .get(statApi, {
          params: {
            startTime: this.daterange[0],
            endTime: this.daterange[1],
            type: this.type,
          },
          responseType: "arraybuffer",
        })
        .then(
          (res) => {
            this.exloading = false;
            if (res.status == 200) {
              let blob = new Blob([res.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              }); // res就是接口返回的文件流了
              let fileName = decodeURI(
                res.headers["content-disposition"].split(";")[1].split("=")[1]
              );
              let url = window.URL || window.webkitURL;
              let fileURL = url.createObjectURL(blob);
              let a = document.createElement("a");
              a.href = fileURL;
              a.target = "_self";
              a.download = fileName;
              a.click();
              url.revokeObjectURL(fileURL);
            } else {
              this.$message.error("导出失败！");
            }
          },
          (error) => {
            this.exloading = false;
            this.$message.error("导出失败！");
          }
        );
    },
  },
};
</script>

<style scoped>
.capacity-module-select >>> .el-input__inner {
  padding-left: 5px;
  border-radius: 0;
  font-size: 12px;
  padding-right: 20px;
}
.capacity-module-select >>> .el-select .el-input.is-focus .el-input__inner {
   border-color: #6c85ff;
}
</style>


// WEBPACK FOOTER //
// src/view/iot/components/capacityDetail.vue